/* src/app/forms/gridview/filterview/filterview.component.css */
.chips-row {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  padding: 6px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
}
.expression-input {
  flex: 1;
  min-width: 160px;
  border: none;
  box-shadow: none;
  background: transparent;
}
.twocolumns {
  width: 100%;
  display: flex;
  align-items: flex-start;
  clear: both;
  content: "";
  padding-top: 6px;
  gap: 4px;
}
textarea {
  height: 50px;
}
.id {
  width: 22%;
}
.description {
  width: calc(16% - 10px);
  margin-right: 10px;
}
.andor {
  width: calc(15% - 10px);
  margin-left: 10px;
}
.value {
  width: calc(40% - 10px);
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.operator {
  width: calc(40% - 10px);
  padding-left: 10px;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.cdk-drop-list-dragging {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.category-chip.category-chip.category-chip {
  width: fit-content;
  max-width: 100%;
  color: #12283a;
  cursor: grab;
}
.category-chip__text {
  width: calc(100%);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter-container {
  font-size: 90%;
}
/*# sourceMappingURL=filterview.component.css.map */
